import Chart from "chart.js"
const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
]

const Utiles = {
  resetearGrafica(contenedor, grafica, id) {
    const $contenedorGrafica = document.querySelector(contenedor)
    let $grafica = document.querySelector(grafica)
    $grafica.remove()
    let $nuevaGrafica = document.createElement("canvas")
    $nuevaGrafica.setAttribute("id", id)
    $contenedorGrafica.appendChild($nuevaGrafica)
  },

  generarGrafica(tipo, array, contenedor, grafica, id) {
    this.resetearGrafica(contenedor, grafica, id)

    const labels = this.generarEtiquetas(array)
    const totales = this.generarValores(array)

    const data = {
      labels: labels,
      datasets: [
        {
          label: "Total ",
          data: totales,
          backgroundColor: this.generarColores(labels.length),
          fill: false,
          tension: 0.1,
          borderWidth: 3,
        },
      ],
    }

    var ctx = document.getElementById(id).getContext("2d")

    var options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    }

    new Chart(ctx, {
      responsive: true,
      type: tipo,
      data: data,
      options: options,
    })
  },

  generarColores(tamanio) {
    const colores = []
    for (let i = 0; i < tamanio; i++) {
      colores.push("#" + Math.floor(Math.random() * 16777215).toString(16))
    }

    return colores
  },

  cambiarNumeroANombreMes(array) {
    for (let i = 0; i < array.length; i++) {
      let pos = array[i].mes
      array[i].mes = MESES[pos - 1]
    }
    return array
  },

  generarEtiquetas(array) {
    const labels = array.map((elemento) => {
      return elemento[Object.keys(elemento)[0]]
    })
    return labels
  },

  generarValores(array) {
    const totales = array.map((elemento) => {
      return elemento.totalVentas
    })
    return totales
  },

  /** Unidades del producto al detal que rinde UN envase (cantidad_base / cantidad_paquete). */
  unidadesPorEnvase(paquete) {
    if (!paquete) return 0

    const declarado = Number(paquete.unidades_por_envase)
    if (Number.isFinite(declarado) && declarado > 0) return declarado

    const cantP = parseFloat(paquete.cantidad_paquete) || 0
    const cantB = parseFloat(paquete.cantidad_base) || 0
    return cantP > 0 ? cantB / cantP : 0
  },

  /**
   * Un envase solo sirve para reponer el detalle si rinde 1 unidad o más.
   * Con una vinculación invertida (1 envase = 0.04 unidades) abrir no cubre la demanda y
   * el backend la rechaza: la UI no debe contar ese stock como disponible.
   */
  puedeAbrirEnvase(paquete) {
    return Utiles.unidadesPorEnvase(paquete) >= 1
  },

  /** Unidades extra que aportan los envases CON STOCK de un producto al detal. */
  unidadesDesdeEnvases(producto) {
    if (!producto || producto.paquetes_de || !Array.isArray(producto.paquetes)) {
      return 0
    }

    return producto.paquetes.reduce((sum, paquete) => {
      if (!Utiles.puedeAbrirEnvase(paquete)) return sum
      const stock = parseFloat(paquete.existencia_paquete) || 0
      return sum + stock * Utiles.unidadesPorEnvase(paquete)
    }, 0)
  },

  /**
   * Envases que consume el detalle ya vendido por encima de su stock (deducción cruzada).
   * Se limita al stock propio del envase: no se puede "consumir" lo que no existe.
   */
  envasesConsumidosPorDetalle(producto, listaProductos) {
    if (!producto || !producto.paquetes_de || !Array.isArray(listaProductos)) {
      return 0
    }

    if (!Utiles.puedeAbrirEnvase(producto.paquetes_de)) return 0

    const baseId = Number(producto.paquetes_de.id_producto_base)
    const lineaBase = listaProductos.find((p) => Number(p.id) === baseId)
    if (!lineaBase) return 0

    const exceso = Math.max(
      0,
      (parseFloat(lineaBase.cantidad) || 0) - (parseFloat(lineaBase.existencia) || 0)
    )
    if (exceso <= 0) return 0

    const unidades = Utiles.unidadesPorEnvase(producto.paquetes_de)
    const stockPropio = parseFloat(producto.existencia) || 0

    return Math.min(stockPropio, Math.ceil(exceso / unidades))
  },

  /**
   * Mensajes que debe ver el operador cuando el sistema abrió productos empaquetados para
   * completar la venta (y cuando una vinculación está invertida y no se pudo usar).
   *
   * El desempaquetado cambia el inventario (suma unidades del producto detal y descuenta
   * el producto empaquetado): sin este aviso el usuario solo ve "registrado con éxito" y
   * no entiende de dónde salieron las unidades ni por qué le bajó el stock.
   *
   * Devuelve descriptores listos para `this.$buefy.toast.open(...)`.
   */
  mensajesDesempaquetado(respuesta) {
    const mensajes = []
    if (!respuesta) return mensajes

    if (respuesta.mensaje_desempaquetado) {
      mensajes.push({
        type: "is-warning",
        duration: 8000,
        message: respuesta.mensaje_desempaquetado,
      })
    }

    if (
      Array.isArray(respuesta.relaciones_invalidas) &&
      respuesta.relaciones_invalidas.length > 0
    ) {
      mensajes.push({
        type: "is-danger",
        duration: 10000,
        message:
          "Revisa la vinculación del producto empaquetado: " +
          respuesta.relaciones_invalidas.join(" | "),
      })
    }

    return mensajes
  },

  /** Redondea cantidades para mostrarlas sin colas de decimales flotantes. */
  redondearCantidad(valor) {
    const numero = Number(valor)
    if (!Number.isFinite(numero)) return 0
    return Math.round(numero * 100) / 100
  },

  formatoMonto(valor, moneda = null) {
    if (isNaN(valor)) return valor

    const numero = Number(valor)

    if (moneda === "bs") {
      return `Bs ${numero.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    }

    return numero.toLocaleString("es-VE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  },

  validarDatos(datos) {
    let errores = []
    for (let [clave, valor] of Object.entries(datos)) {
      if (!valor) errores.push("Debes colocar el valor de " + clave)
    }
    return errores
  },

  calcularTotalGanancia(ventas) {
    let total = 0
    ventas.forEach((venta) => {
      venta.productos.forEach((producto) => {
        total +=
          parseFloat(producto.cantidad * producto.precio) -
          parseFloat(producto.cantidad * producto.precioCompra)
      })
    })
    return total
  },

  calcularProductosVendidos(ventas) {
    let total = 0
    ventas.forEach((venta) => {
      venta.productos.forEach((producto) => {
        total += parseFloat(producto.cantidad)
      })
    })
    return total
  },
}

export default Utiles
